

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.visible = this.open;
  },
  methods: {
    toggleDropdown() {
      this.visible = !this.visible;
    },
  },
};
